import { AxiosResponse } from 'axios';

import { api } from 'api';
import { PaginatedQuery } from 'features/app/ts/PaginatedQuery';
import { OrderReportFilters } from 'features/order-history/ts/OrderReportFilters';

export type GetFileRequestParams = PaginatedQuery & OrderReportFilters;

export type GetFileRequestResponse = Promise<AxiosResponse<File>>;

export const getFileRequest = async (apiUrl: string, params?: GetFileRequestParams): GetFileRequestResponse => {
  const response = await api.get(apiUrl, {
    responseType: 'blob',
    params: { ...params, report: true },
  });

  const contentDisposition = response.headers['content-disposition'];
  const file = response.data;

  file.name = contentDisposition.split('attachment; filename=')[1];

  return { ...response, data: file };
};
